import request from '@/utils/request'
import { downloadFileFromStream } from '@/utils/index'

export function getTotal(data) {
  return request({
    url: `/eos/order-analysis/order-number`,
    method: 'POST',
    data,
  })
}

export function getTotal2(data) {
  return request({
    url: `/eos/order-analysis/order-goods-number`,
    method: 'POST',
    data,
  })
}

export function getList(data) {
  return request({
    url: `/eos/order-analysis/order-number-list/${data.code}`,
    method: 'POST',
    data,
  })
}

export function getEnumOptions() {
  return request({
    url: `/eos/order-analysis/order-number-enum`,
    method: 'GET',
  })
}

export function getStoreOptions() {
  return request({
    url: `/eos/order-analysis/order-store-list`,
    method: 'GET',
  })
}

export function getSupperOptions() {
  return request({
    url: `/eos/order-analysis/order-supper-list`,
    method: 'GET',
  })
}

export function getStyleOptions() {
  return request({
    url: `/eos/order-analysis/order-style-list`,
    method: 'GET',
  })
}

export function getProductRemarkOptions() {
  return request({
    url: `/eos/order-analysis/order-productRemark-list`,
    method: 'GET',
  })
}

export function getOrderList(data) {
  return request({
    url: `/eos/order-analysis/order-list`,
    method: 'POST',
    data,
  })
}

export function getProductList(data) {
  return request({
    url: `/eos/order-analysis/order-goods-list`,
    method: 'POST',
    data,
  })
}

export const getLoginCount = (data) => {
  return request({
    url: '/exhibition/login-log/login-log-count',
    method: 'POST',
    data,
  })
}

export function getLoginList(data) {
  return request({
    url: '/exhibition/login-log/page',
    method: 'POST',
    data,
  })
}

export const getOrgNumber = (data) => {
  return request({
    url: '/eos/order-analysis/order-org-number',
    method: 'POST',
    data,
  })
}

export const getOrgList = (data) => {
  return request({
    url: '/eos/order-analysis/org-list',
    method: 'POST',
    data,
  })
}

// export async function exportInventory(data) {
//   const res = await request({
//     headers: {
//       timeout: 600000,
//     },
//     url: '/exhibition/product/exportAllGood',
//     method: 'GET',
//     responseType: 'blob',
//     data,
//   }).then((data2) => downloadFileFromStream(data2, data.filename))
//   return res
// }

export async function exportInventory(data) {
  const res = await request({
    url: '/exhibition/product/exportAllGood',
    method: 'GET',
    responseType: 'blob',
  }).then((res) => downloadFileFromStream(res.data, data.filename))
  return res
}
